import { AppDomainConfig } from "../../envConfig";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["ch"],
  font: "16px arial",
  iconCategories,
  id: "RhB",
  name: "RhB",
  slug: "rhb",
  ...colors,
  layoutConfigs: {
    rhb_bahnersatz_a4: {
      thumbnail: "rhb_bahnersatz_a4.png",
    },
  },
};
export default config;
